import { ErrorMessage, FastField } from 'formik';
import React from 'react';
import ShowError from '../ShowError.jsx';

const SelectBox = ({
    name,
    options,
    label,
    title,
    className,
    fieldCalss,
    ...rest
}) => {
    return (
        <div className={`flex flex-col ${className || ""}`}>
            {label && (
                <label htmlFor={name} className="ms-1">
                    {label}
                </label>
            )}
            <FastField name={name} id={name} as="select"
                className={`w-full bg-transparent mt-1
                border border-gray-400 px-2 py-1 rounded-lg ${fieldCalss || ""}`}
                {...rest}
            >
                {title && (
                    <option value="" disabled>
                        {title}
                    </option>
                )}
                {options.map((op, index) => (
                    <option
                        key={`${Math.random()}_${index}`}
                        value={op.value}
                    >
                        {op.text}
                    </option>
                ))}
            </FastField>
            <ErrorMessage name={name} component={ShowError} />
        </div>
    );
}

export default SelectBox;
